import { useActiveSidebarLibrary } from '@/components/Sidebars/useActiveDirectory';
import { useAuth } from '@/context/AuthContext';
import useAnalytics from '@/lib/analytics/useAnalytics';
import { api } from '@/lib/trpc/react';
import type { RouterInputs } from '@unriddle/api';
import { useCallback } from 'react';
import { toast } from 'sonner';
import { useLeftSidebar } from './useLeftSidebar';
import { useRenameGroup } from './useRenameGroup';
import { useWorkspaceActions } from './useWorkspace';

export const useCreateEmptyFolder = () => {
  const { track } = useAnalytics();

  const { addChatbot, deleteChatbot } = useWorkspaceActions();
  const { currentPath } = useActiveSidebarLibrary();
  const { user } = useAuth();

  const { setShowLeftSidebar } = useLeftSidebar();

  const { setGroupIdToRename } = useRenameGroup();
  const { mutate, isPending } = api.workspace.createEmptyFolder.useMutation({
    onMutate: (data) => {
      setShowLeftSidebar(true);
      addChatbot({
        id: data.id,
        name: data.name ?? 'Untitled',
        type: 'GROUP',
        authors: null,
        createdAt: new Date(),

        teamId: data.teamId ?? null,
        groupId: data.groupId ?? null,
        displayOrder: -1,
        summary: null,
        groupCollapsed: true,
        documentUrl: null,
        url: null,
        isIndexed: false,
        ingestionStatus: null,
        userId: user?.id ?? '',
        lastViewedAt: null,
      });
    },
    onSuccess: () => {
      track('library_folder_created');
    },
    onError: (_error, vars) => {
      deleteChatbot(vars.id);
      toast.error('Failed to create group');
    },
  });

  const createEmptyFolder = useCallback(
    async (
      options: RouterInputs['workspace']['createEmptyFolder'],
      disableRenameFocus = false,
    ) => {
      // let groupId: string | undefined;
      // let teamId: string | undefined;
      // if (currentPath?.type === 'GROUP') groupId = currentPath.id;
      // if (currentPath?.teamId) teamId = currentPath.teamId;

      if (!disableRenameFocus) setGroupIdToRename(options.id);

      mutate({ ...options });
    },
    [mutate, currentPath],
  );

  return {
    isPending,
    createEmptyFolder,
  };
};
